export const isToday = (dateValue: string | Date) => {
    const today = new Date();
    const date = new Date(dateValue);
    return today.getDate() === date.getDate() && today.getMonth() === date.getMonth() && today.getFullYear() === date.getFullYear();
};
